<div *ngIf="message" class="modal" tabindex="-1" role="dialog" style="display:block!important;z-index: 999999 !important;">  
    <div class="modal-dialog custom-alert" role="document">  
        <div class="modal-content">  
  
            <div *ngIf="message?.type == 'confirm'" class="modal-body">  
                <div class="row">  
                    <div class="col-md-12">  
                        <p class="text-center opensans-normal-regal-blue-20px">{{message.text}}</p>  
                    </div>  
                </div>  
                <div class="row">  
                    <div class="col-md-12">  
                        <p class="confirm-button row">  
                            <a (click)="message.noFn()"  class="col-md-6"  >  
                                <button class="btn btn-outline-custom" style="padding: 10px 75px!important;width: 180px;">No</button>  
                            </a>  
                            <a (click)="message.yesFn()"  class="col-md-6" >  
                                <button class=" btn-add_2" style="padding: 10px 75px!important;width: 180px">Yes</button>  
                            </a>  
                        </p>  
                    </div>  
                </div>  
            </div>  
        </div>  
    </div>  
</div>  